import { BoxProps, Stack, Typography, styled } from '@mui/material';
import { forwardRef } from 'react';

type MapControlHeaderProps = BoxProps & {
  title: string;
  actions?: React.ReactNode;
};

export const MapControlHeader = styled(
  forwardRef<HTMLDivElement, MapControlHeaderProps>(
    ({ title, actions, ...props }, ref) => (
      <Stack
        ref={ref}
        direction='row'
        {...props}
        sx={{
          padding: 5,
          ...props.sx,
          borderBottom: '1px solid',
          borderColor: 'divider',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography
          variant='body1'
          sx={{
            margin: 0,
            fontWeight: 500,
            color: 'text.primary',
          }}
        >
          {title}
        </Typography>
        {actions && (
          <Stack direction='row' sx={{ alignItems: 'center' }} spacing={1}>
            {actions}
          </Stack>
        )}
      </Stack>
    )
  )
)({});
